export const marketplaceEs = {
  marketplace: {
    title: "Mercado",
    subtitle: "Compra y vende productos agrícolas",
    products: "Productos",
    services: "Servicios",
    myListings: "Mis Listados",
    orders: "Pedidos",
    addListing: "Añadir Listado",
    searchProducts: "Buscar productos...",
    categories: "Categorías",
    seeds: "Semillas",
    fertilizers: "Fertilizantes",
    pesticides: "Pesticidas",
    equipment: "Equipamiento",
    price: "Precio",
    quantity: "Cantidad",
    addToCart: "Añadir al Carrito",
    buyNow: "Comprar Ahora",
    contactSeller: "Contactar Vendedor"
  },
  productMarketplace: {
    title: "Mercado de Productos",
    subtitle: "Compra y vende productos agrícolas directamente con productores, exportadores y mayoristas",
    activeListings: "Listados Activos",
    verifiedProducers: "Productores Verificados",
    transactionsThisMonth: "Transacciones Este Mes",
    avgDeliveryTime: "Tiempo Medio de Entrega",
    searchPlaceholder: "Buscar productos, productores, regiones...",
    listProduct: "Listar Producto",
    tabs: {
      browse: "Explorar",
      sell: "Vender",
      orders: "Pedidos",
      analytics: "Análisis"
    },
    categories: {
      cereals: "Cereales y Granos",
      fruits: "Frutas",
      vegetables: "Verduras",
      oils: "Aceites y Grasas"
    },
    products: "productos",
    featuredProducts: "Productos Destacados",
    featuredDesc: "Productos mejor valorados de productores verificados",
    contact: "Contactar",
    producers: "Productores",
    producersDesc: "Vende tu cosecha directamente a compradores y obtén mejores precios.",
    registerAsProducer: "Registrarse como Productor",
    exporters: "Exportadores",
    exportersDesc: "Conecta con mercados internacionales y expande tu alcance globalmente.",
    connectWithExporters: "Conectar con Exportadores",
    wholesalers: "Mayoristas",
    wholesalersDesc: "Encuentra compradores al por mayor para tu producción con precios competitivos.",
    findWholesalers: "Encontrar Mayoristas",
    listYourProducts: "Lista Tus Productos",
    listDesc: "Crea listados para vender tus productos agrícolas",
    startSelling: "Comienza a vender tus productos a una red de compradores verificados",
    createListing: "Crear Listado",
    yourOrders: "Tus Pedidos",
    noOrders: "Sin pedidos aún. Comienza a comprar o vender para ver tus pedidos aquí.",
    salesAnalytics: "Análisis de Ventas",
    analyticsComingSoon: "Panel de análisis próximamente. Rastrea tu rendimiento de ventas aquí."
  },
  prefinancing: {
    title: "Prefinanciación y Factoring",
    subtitle: "Accede a soluciones de financiación con nuestros socios financieros de confianza",
    calculateFinancing: "Calcular Financiación",
    stats: {
      totalFunded: "Total Financiado",
      activeFarmers: "Agricultores Activos",
      avgApprovalTime: "Tiempo Medio de Aprobación",
      successRate: "Tasa de Éxito"
    },
    tabs: {
      options: "Opciones",
      partners: "Socios",
      apply: "Solicitar",
      myFinancing: "Mi Financiación"
    },
    options: {
      prefinancing: {
        title: "Financiación Pre-Cosecha",
        description: "Obtén capital antes de tu cosecha para cubrir costes operativos",
        features: [
          "Financia hasta el 70% del valor esperado de cosecha",
          "Pago flexible después de la cosecha",
          "Sin garantía requerida para granjas verificadas"
        ]
      },
      factoring: {
        title: "Factoring de Facturas",
        description: "Convierte tus facturas en flujo de caja inmediato",
        features: [
          "Recibe hasta el 90% del valor de factura inmediatamente",
          "Factoring sin recurso disponible",
          "Aprobación rápida en 24-48 horas"
        ]
      }
    },
    interestRate: "Tipo de Interés",
    term: "Plazo",
    learnMore: "Saber Más",
    howItWorks: "Cómo Funciona",
    howItWorksDesc: "Pasos sencillos para acceder a financiación agrícola",
    steps: {
      step1: { title: "Enviar Solicitud", description: "Completa tu perfil y solicitud de financiación" },
      step2: { title: "Revisión de Documentos", description: "Nuestros socios verifican los datos de tu granja" },
      step3: { title: "Aprobación", description: "Recibe condiciones de financiación en 48h" },
      step4: { title: "Recibir Fondos", description: "Dinero transferido a tu cuenta" }
    },
    ourPartners: "Nuestros Socios Financieros",
    partnersDesc: "Instituciones de confianza especializadas en financiación agrícola",
    partners: {
      specialty: {
        prefinancing: "Pre-Financiación de Cosecha",
        agricultural: "Préstamos Agrícolas",
        factoring: "Factoring de Facturas",
        sustainable: "Agricultura Sostenible"
      }
    },
    funded: "Financiado",
    viewDetails: "Ver Detalles",
    applyForFinancing: "Solicitar Financiación",
    applyDesc: "Completa la solicitud para obtener ofertas de financiación personalizadas",
    applicationForm: "Completa nuestro sencillo formulario de solicitud para comenzar",
    startApplication: "Iniciar Solicitud",
    useCalculator: "Usar Calculadora",
    benefits: {
      secure: { title: "Proceso Seguro", description: "Encriptación de nivel bancario y socios verificados" },
      competitive: { title: "Tasas Competitivas", description: "Mejores tasas negociadas con múltiples socios" },
      fast: { title: "Aprobación Rápida", description: "Aprobado en 48 horas" }
    },
    myActiveFinancing: "Mi Financiación Activa",
    noActiveFinancing: "Sin financiación activa. Solicita financiación para hacer crecer tu operación.",
    applyNow: "Solicitar Ahora"
  }
};
